//export const FAIRERS_URL = "https://demo.fairers.com";
export const FAIRERS_URL = "https://stage.fairers.com";
//export const FAIRERS_URL = "https://revolution.fairers.com";

//export const API_URL = "https://api-demo.fairers.com";
export const API_URL = "https://api-stage.fairers.com";
//export const API_URL = "https://api-revolution.fairers.com";

//LOACL API
//export const API_URL = "/api";
